import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {ContatosService} from '../../services/contatos.service';

/**
 * Perfil do cliente pelos pedidos anteriores nesta loja: canal habitual,
 * entrega/retirada, endereço, pagamento e último pedido, cada um com a
 * evidência ("usou este endereço em 8 dos últimos 10 pedidos"). Mesmo
 * cálculo que a Mia usa; aqui o atendente lê em dois segundos.
 * Entra no cadastro do cliente e, compacto, na tela de atendimento.
 */
@Component({
  selector: 'app-perfil-cliente',
  templateUrl: './perfil-cliente.component.html',
  styleUrls: ['./perfil-cliente.component.scss']
})
export class PerfilClienteComponent implements OnChanges, OnDestroy {
  /** Telefone completo (dígitos, com DDI) — a tela de conversas passa o wa_id. */
  @Input() telefone: string;
  /** Contato do cadastro (codigoPais + telefone) — alternativa ao telefone. */
  @Input() contato: any;
  /** Versão compacta para o painel da conversa. */
  @Input() compacto = false;

  perfil: any = null;
  carregando = false;
  semHistorico = false;
  erro = '';
  private sequencia = 0;
  private destruido = false;

  constructor(private contatos: ContatosService) {}

  ngOnChanges() {
    this.sequencia++;
    this.perfil = null;
    this.semHistorico = false;
    this.erro = '';
    if (!this.telefoneCompleto) return;
    void this.carregue();
  }

  ngOnDestroy() { this.destruido = true; }

  get telefoneCompleto(): string {
    const bruto = String(this.telefone || '');
    // LID não é telefone: sem identificação não buscamos o perfil de outro contato
    if (bruto.includes('@')) return '';
    if (bruto) {
      const digitos = bruto.replace(/\D/g, '');
      return /^\d{10,15}$/.test(digitos) ? digitos : '';
    }
    const tel = String(this.contato?.telefone || '');
    if (!tel || tel.includes('@')) return '';
    const completo = `${this.contato?.codigoPais || '+55'}${tel}`.replace(/\D/g, '');
    return /^\d{10,15}$/.test(completo) ? completo : '';
  }

  async carregue() {
    const seq = ++this.sequencia;
    this.carregando = true;
    try {
      const perfil = await this.contatos.obtenhaPerfilCliente(this.telefoneCompleto);
      if (seq !== this.sequencia || this.destruido) return;
      this.perfil = perfil || null;
      this.semHistorico = !perfil;
    } catch (erro: any) {
      if (seq !== this.sequencia || this.destruido) return;
      this.erro = typeof erro === 'string' ? erro : 'Não foi possível carregar o perfil do cliente.';
    } finally {
      if (seq === this.sequencia) this.carregando = false;
    }
  }

  get canal(): string {
    switch (this.perfil?.canal?.habitual) {
      case 'LINK': return 'Pede pelo link do cardápio';
      case 'CONVERSA': return 'Pede pela conversa com a Mia';
      case 'OUTRO': return 'Pede por outros canais';
      default: return '';
    }
  }

  get recebimento(): string {
    switch (this.perfil?.entrega?.habitual) {
      case 'ENTREGA': return 'Recebe em casa';
      case 'RETIRADA': return 'Retira na loja';
      case 'LOCAL': return 'Consome no local';
      default: return '';
    }
  }

  get quandoFoiOUltimo(): string {
    const dias = Number(this.perfil?.ultimoPedido?.feitoHaDias);
    if (!Number.isFinite(dias)) return '';
    if (dias === 0) return 'Hoje';
    if (dias === 1) return 'Ontem';
    return `Há ${dias} dias`;
  }

  get clienteDesde(): string {
    const data = this.perfil?.primeiroPedidoEm ? new Date(this.perfil.primeiroPedidoEm) : null;
    if (!data || isNaN(data.getTime())) return '';
    return data.toLocaleDateString('pt-BR', {month: 'short', year: 'numeric'}).replace('.', '');
  }
}
